/** Default rows per page for tables and their requests. */
export const LIMIT_PAGE = 20;
export const ASYNC_LIMIT_PAGE = 10;
export const LIMIT_PAGE_MORE = 1000;
export const LIMIT_CHARTS_PAGE = LIMIT_PAGE;
export const LIMIT_SERVICE_TASK = 10;
export const LIMIT_VEHICLE_GROUP = 10;
export const LIMIT_FILTER_OPTIONS = 10;
export const LIMIT_USER = 10;
export const LIMIT_MORE_USER = 1000;
export const LIMIT_ROLE_LIST = 1000;
export const DELAY_FOR_SEARCH = 300;
export const LIMIT_VEHICLES = 1000;
export const LIMIT_TELEMATIC_VEHICLES = 1000;
export const LIMIT_NEAREST_VENDORS = 40;
export const LIMIT_VENDORS = 1000;
// Machine formats for API payloads, query params and <input> values; never
// shown to users. Display dates with displayDate()/formatDate() from
// Shared/Utils/display, which follow the company's date and time settings.
export const API_DATE_FORMAT = "YYYY-MM-DD";
// <input type="time"> takes a 24-hour value; "hh:mm" turned 2:37 PM into 02:37
export const INPUT_TIME_FORMAT = "HH:mm";
/** Shown wherever a value is missing. */
export const EMPTY_VALUE = "—";
export const TEMPLATE_LIMIT = 30;
export const NOTIFICATIONS_LIMIT = 30;

// The whole catalogue fits on one page; it is grouped by category instead.
export const REPORT_LIMIT_PAGE = 100;
export const ACCESS_TOKEN_LIFETIME_DAYS = 3;
export const REFRESH_TOKEN_LIFETIME_DAYS = 14;
export const LIMIT_DASHBOARD_REMINDER_PAGE = 20;
// Chicago coordinates
export const DEFAULT_MAP_CENTER = {
  lat: 41.8781,
  lng: -87.6298,
};
export const LIMIT_MAP_MARKERS = 100;
export const DEFAULT_MAP_ZOOM = 7;

/** Where every "contact support" link in the app goes. */
export const SUPPORT_EMAIL = "support@inclusivetec.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
